import deepmerge from 'deepmerge';
import { useSelector } from 'react-redux';
import { GB } from '@clearscore-group/lib.config.i18n';
import { selectors } from '@clearscore-group/lib.redux.market';
var isObject = function isObject(value) {
  return !!value && typeof value === 'object' && value.constructor === Object;
};
var useMarketConfig = function useMarketConfig(marketConfig) {
  if (!marketConfig || !isObject(marketConfig)) throw new Error('A market config object must be provided');
  var market = useSelector(selectors.getActiveMarket);

  // GB market defaulting is temporary and will be removed.
  // Common config should be placed under a 'common' property.
  var baseConfig = marketConfig.common || marketConfig[GB];
  if (marketConfig[market]) {
    return baseConfig ? deepmerge(baseConfig, marketConfig[market], {
      arrayMerge: function arrayMerge(_, sourceArray) {
        return sourceArray;
      }
    }) : marketConfig[market];
  }
  return baseConfig || null;
};
export default useMarketConfig;